<template>
  <div class="realtimeData">
    <div class="search-box padding-left">
      <div class="search-item">
        <span class="title">决策模型：</span>
        <el-select @change="ChangeDecisionId" v-model="decisionId" clearable placeholder="请选择">
          <el-option v-for="item in ModelDecision" :key="item.id" :label="item.groupName" :value="item.id"> </el-option>
        </el-select>
        <span class="title">日期选择：</span>
        <el-date-picker class="mg_right1" v-model="dateRange" type="datetimerange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" v-if="timeshow == '0'" :default-time="['00:00:00', '23:59:590']"> </el-date-picker>
        <el-select v-model="dateType" v-if="timeshow == '1'">
          <el-option value="1" label="最近1小时"></el-option>
          <el-option value="2" label="最近4小时"></el-option>
          <el-option value="3" label="今天"></el-option>
          <el-option value="4" label="昨天"></el-option>
          <el-option value="5" label="最近7天"></el-option>
          <el-option value="6" label="最近1月"></el-option>
        </el-select>
      </div>
      <el-button type="primary" style="margin-right: 20px" @click="timechange()">日期切换</el-button>

      <div class="search-item" style="margin-bottom: 14px !important; margin-right: 20px">
        <el-button type="primary" @click="showbox" icon="el-icon-date">属性选择</el-button>
      </div>

      <div class="search-item">
        <el-button type="primary" @click="serchKey" class="search_btn">查 询</el-button>
      </div>
    </div>

    <div class="realtimeDataChart">
      <div class="realtimeDataChart-body">
        <div id="myChart5" class="realtimeDataChart-right-chart" style="width: 100%; height: 100%; display: inline-block"></div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="选择类比属性" :visible.sync="dialogVisible" width="780px" :before-close="handleClose">
      <div class="equipmentcenter-opption-box">
        <el-form ref="ruleForm" :rules="rules" :model="form" label-width="140px">
          <ul v-for="(form, index) in form" :key="index">
            <el-form-item :label="`属性${index + 1}：`" prop="cname">
              <div style="width: 200px; float: left; margin-right: 20px">
                <el-select v-model="form.eid" filterable placeholder="请选择设备" class="mg_right1 centerfont" maxlength="50" @change="getattr(index)">
                  <el-option :label="item.name" :value="item.id" v-for="(item, index) in deviceList" :key="index">
                    <el-popover placement="top-start" width="225" open-delay="1000" trigger="hover" :content="item.name" v-if="item.name.length > 12">
                      <span slot="reference" class="limitoption">{{ item.name }}</span>
                    </el-popover>
                    <span class="limitoption" v-else>{{ item.name }}</span>
                  </el-option>
                </el-select>
              </div>
              <div style="width: 200px; float: left">
                <el-select v-model="form.attributeId" filterable placeholder="请选择设备属性" class="mg_right1 centerfont" maxlength="50">
                  <el-option :label="item.name" :value="item.id" v-for="(item, index) in form.attrList" :key="index">
                    <el-popover placement="top-start" width="225" open-delay="1000" trigger="hover" :content="item.name" v-if="item.name.length > 12">
                      <span slot="reference" class="limitoption">{{ item.name }}</span>
                    </el-popover>
                    <span class="limitoption" v-else>{{ item.name }}</span>
                  </el-option>
                </el-select>
                <a class="sc-btn3" @click="del(index)">删除</a>
              </div>
            </el-form-item>
          </ul>
          <el-form-item>
            <a class="td-opption" @click="add()">+添加字段</a>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import echarts from 'echarts'
import store from '@/store/index'
export default {
  name: 'realtimeData',
  components: {},
  props: {
    ModelDecision: ''
  },
  data() {
    return {
      timeshow: '0',
      dialogVisible: false,
      form: [
        {
          eid: '',
          attributeId: '',
          attrList: []
        }
      ],
      decisionId: '',
      usertypeshow: '',
      dateType: '',
      active: '1',
      gettera: '1',

      deviceType: '',
      dateRange: '',
      groupId: '',
      eid: '',
      mode: '1',
      alltype: [],
      groupList: [],
      deviceList: [],
      tablelist: [],
      tableData: []
    }
  },
  methods: {
    ChangeDecisionId(val) {
      this.decisionId = val
      // this.getList()
      this.getDeviceDesc()
    },

    timechange() {
      if (this.timeshow == '1') {
        this.timeshow = '0'
        this.dateType = undefined
        this.getNowdate()
      } else {
        this.timeshow = '1'
        this.dateType = '1'
        this.dateRange = undefined
      }
      this.serchKey()
    },
    getattr(index) {
      this.getRealDatasByEid(this.form[index].eid, index)
    },
    showbox() {
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    add: function () {
      let cope = { eid: '', attributeId: '', attrList: [] }
      this.form.push(cope)
    },
    del: function (index) {
      this.form.splice(index, 1)
    },
    filteremojifun(e, name, ruleForm) {
      //过滤表情
      this.$utils.filteremojifun(this, e, name, ruleForm)
    },
    serchKey() {
      this.getAlarmChart()
    },
    selecType(e) {
      this.active = e
    },

    getDeviceDesc() {
      //获取设备分类
      //获取分组对应的设备
      console.log(this.decisionId, 789)

      let a = ''
      this.ModelDecision.map(item => {
        if (item.id == this.decisionId) {
          a = item.groupId
        }
      })
      this.$api.device.getNumericalsByGroupId({ groupId: a }).then(res => {
        if (res.code == 200) {
          this.deviceList = res.data
        }
      })
    },

    getallGroup() {
      //获取分组列表
      this.$api.device.getallGroup().then(res => {
        if (res.code == 200) {
          this.groupList = res.data
        }
        this.groupId = res.data[0].id
      })
      this.$forceUpdate()
    },
    getDevicesByGroupId(id) {
      //获取设备
      this.$api.device.getDeviceAttributeList(id).then(res => {
        if (res.code == 200) {
          //this.deviceList = res.data

          if (res.data.length > 0) {
            this.deviceList = []

            for (var i = 0; i < res.data.length; i++) {
              var obj = {}
              if (res.data[i].cname == undefined) {
                res.data[i].cname = '未命名'
              }
              obj.name = res.data[i].cname
              obj.id = res.data[i].id
              this.deviceList.push(obj)
            }
            this.form[0].eid = res.data[0].id
          } else {
            this.deviceList = []
            this.eid = ''
          }
        }

        this.$forceUpdate()
      })
    },
    getRealDatasByEid(id, index) {
      //获取属性
      if (id == '' || id == undefined) {
        return false
      }
      this.$api.device.getAttributesByEid(id).then(res => {
        if (res.code == 200) {
          //this.deviceList = res.data
          if (res.data.length > 0) {
            this.form[index].attrList = []
            for (var i = 0; i < res.data.length; i++) {
              var obj = {}
              obj.name = res.data[i].cname
              obj.id = res.data[i].id
              this.form[index].attrList.push(obj)
            }
            this.form[index].attributeId = res.data[0].id
          } else {
            this.form[index].attrList = []
            this.attributeId = ''
          }
        }
        this.$forceUpdate()
      })
    },

    selecType2(e) {
      this.gettera = e
      this.mode = e
      if (e == 0) {
        var datee = new Date()
        var year = datee.getFullYear()
        var month = datee.getMonth()
        var day = datee.getDate()
        var hours = datee.getHours()
        var hours2 = datee.getHours() + 1
        this.dateRange = [new Date(year, month, day, hours, 0, 0), new Date(year, month, day, hours2, 0, 0)]
      } else {
        this.getNowdate()
      }
      this.serchKey()
    },
    getAlarmChart() {
      //
      if (this.dateRange == undefined || this.dateRange == null || this.dateRange == '') {
        var beginDate = undefined
        var endDate = undefined
      } else {
        var beginDate = this.$utils.zhDatetime(this.dateRange[0])
        var endDate = this.$utils.zhDatetime(this.dateRange[1])
      }
      if (this.form.length == 0) {
        this.$toaster.error('请至少选择一组属性')
        return false
      } else {
        for (var i = 0; i < this.form.length; i++) {
          if (this.form[i].eid == '' || this.form[i].attributeId == '') {
            // this.$toaster.error("请选择属性");
            return false
          }
        }
      }

      var obj = {
        attributes: this.form,
        endDate: endDate,
        startDate: beginDate,
        dateType: this.dateType,
        token: store.state.user.token
      }
      this.$api.device.getAnalogicalAna1lysisChart(obj).then(res => {
        if (res.code == 200) {
          var datax = []
          var datayy = []
          var color = ['#0356FE', '#eb2d08', '#00ff00', '#ff00ff']
          for (var j = 0; j < res.data.xTimes.length; j++) {
            datax.push(this.$utils.zhDatetime(res.data.xTimes[j]))
          }
          var title = []
          for (var i = 0; i < res.data.yDatas.length; i++) {
            //这层遍历出几个属性
            var datay = []

            for (var k = 0; k < res.data.yDatas[i].datas.length; k++) {
              // 这层遍历出该属性下的所有点的数据
              var value = res.data.yDatas[i].datas[k].value

              datay.push(parseFloat(value).toFixed(2))
            }

            title.push(res.data.yDatas[i].deviceName)
            var obj = {
              name: res.data.yDatas[i].deviceName,
              data: datay,
              type: 'line',
              smooth: true,
              symbolSize: 0,
              itemStyle: {
                normal: {
                  // color:'#0356FE',
                  color: color[i],
                  lineStyle: {
                    //color:'#0356FE'
                    color: color[i]
                  }
                }
              },
              areaStyle: {
                // normal:{
                //    //  color:"#d2e9ef"
                //     color:color2[i],
                // }
              } //区域颜色渐变
            }
            datayy.push(obj)
          }

          this.drawLine(datax, datayy, title)
          this.isloading = false
        }
      })
    },

    drawLine(datax, datayy, title) {
      this.$forceUpdate()
      var myChart = document.getElementById('myChart5')
      // myChart.removeAttribute('echarts_instance')
      var chartObj = echarts.init(myChart)
      chartObj.clear()
      chartObj.setOption({
        tooltip: {
          trigger: 'axis',
          position: function (pt) {
            return [pt[0], '10%']
          }
          //formatter: "{a}: {c} ({d}%)"
        },
        legend: {
          data: title,
          top: 20
        },
        grid: {
          top: 60,
          left: 60,
          right: 100,
          bottom: 50
        },
        xAxis: {
          name: '时间',
          nameTextStyle: {
            color: '#c1c1c1',
            padding: [46, 5, 5, 48],
            fontSize: 12
          },
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#EBEEF5'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#c1c1c1',
              fontSize: 10
            },
            margin: 16 //刻度标签与轴线之间的距离。
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#EBEEF5'],
              width: 1,
              type: 'solid'
            }
          },
          data: datax //['17:22:00', '17:24:00', '17:26:00', '17:28:00', '17:30:00', '17:32:00', '17:34:00', '17:36:00', '17:38:00', '17:40:00', '17:42:00']
        },
        yAxis: {
          name: '数值',
          nameTextStyle: {
            color: '#54627D',
            //align:"right",
            padding: [80, 5, 10, -20],
            fontSize: 12
          },
          axisLine: {
            lineStyle: {
              color: '#EBEEF5'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#54627D',
              fontSize: 10
            },
            margin: 20 //刻度标签与轴线之间的距离。
          },
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#EBEEF5'],
              width: 1,
              type: 'solid'
            }
          }
        },
        series: datayy
      })
    },
    getNowdate() {
      var datee = new Date()
      var year = datee.getFullYear()
      var month = datee.getMonth()
      var day = datee.getDate()
      var Hours = datee.getHours() //得到小时

      this.dateRange = [new Date(year, month, day, Hours, 0, 0), new Date(year, month, day, Hours, 59, 59)]
    }
  },
  created() {
    this.usertypeshow = this.$utils.getStorage('userType')
  },
  mounted() {
    this.getNowdate()
    // this.getDeviceDesc();
  },
  watch: {
    dateRange() {
      // this.serchKey()
    },
    decisionId() {
      this.getDeviceDesc()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.sc-btn3 {
  color: red;
  position: absolute;
  top: -1px;
  right: 14px;
  cursor: pointer;
}
.search-box {
  display: flex;
}
.title {
  font-size: 14px;
  color: #647189;
  margin-left: 20px;
}
.realtimeDataChart {
  width: 100%;
  height: 600px;
}
.realtimeDataChart-body {
  height: 100%;
}
</style>
